// import React from 'react';
// import { Container, Button, Box, Typography, Card, CardContent } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { Quiz as QuizIcon, Leaderboard as LeaderboardIcon } from '@mui/icons-material';

// const StudentQuizHome = () => {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', // Gradient background
//         py: 4,
//       }}
//     >
//       <Container maxWidth="sm">
//         <Card
//           sx={{
//             bgcolor: 'background.paper',
//             borderRadius: 2,
//             boxShadow: 3,
//             background: 'linear-gradient(145deg, #ffffff, #f0f0f0)', // Gradient card background
//             transition: 'transform 0.3s, box-shadow 0.3s',
//             '&:hover': {
//               transform: 'scale(1.02)',
//               boxShadow: 6,
//             },
//           }}
//         >
//           <CardContent>
//             <Box sx={{ textAlign: 'center', p: 4 }}>
//               <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//                 Weekly Quiz
//               </Typography>
//               <Typography variant="body1" gutterBottom sx={{ color: 'text.secondary' }}>
//                 Ready to test your knowledge? Choose an option below:
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 startIcon={<QuizIcon />}
//                 sx={{ mt: 3, fontWeight: 'bold' }}
//                 onClick={() => navigate('/quiz')}
//               >
//                 Attempt Quiz
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="secondary"
//                 fullWidth
//                 startIcon={<LeaderboardIcon />}
//                 sx={{ mt: 2, fontWeight: 'bold' }}
//                 onClick={() => navigate('/quiz/leaderboard')}
//               >
//                 View Leaderboard
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       </Container>
//     </Box>
//   );
// };

// export default StudentQuizHome;



import React from 'react';
import { useNavigate } from 'react-router-dom';

const StudentQuizHome = () => {
  const navigate = useNavigate();

  return (
    <div className="quiz-home-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .quiz-home-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .quiz-home-container::before {
          content: '';
          position: absolute;
          top: 20%;
          right: 10%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .quiz-home-container::after {
          content: '';
          position: absolute;
          bottom: 15%;
          left: 15%;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3.5s ease-in-out infinite;
          animation-delay: 1.8s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(8deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.05); }
        }

        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(255, 255, 255, 0.1); }
          50% { box-shadow: 0 0 30px rgba(255, 255, 255, 0.2); }
        }

        .floating-element-1 {
          position: absolute;
          top: 30%;
          right: 25%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        .floating-element-2 {
          position: absolute;
          bottom: 30%;
          left: 20%;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.04);
          animation: pulse 4s ease-in-out infinite;
          animation-delay: 2s;
        }

        .quiz-wrapper {
          max-width: 600px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 100vh;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1.1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
          max-width: 400px;
          margin: 0 auto;
          line-height: 1.5;
        }

        .quiz-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.6s ease-out 0.4s both;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .quiz-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(0,0,0,0.15);
        }

        .quiz-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .card-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .quiz-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
          animation: glow 3s ease-in-out infinite;
        }

        .card-title {
          font-size: 1.8rem;
          font-weight: 800;
          color: #1f2937;
          margin-bottom: 0.75rem;
        }

        .card-description {
          color: #6b7280;
          font-size: 1rem;
          line-height: 1.6;
        }

        .buttons-container {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .quiz-btn {
          width: 100%;
          padding: 1.5rem 2rem;
          border: none;
          border-radius: 16px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          text-decoration: none;
          font-family: inherit;
          position: relative;
          overflow: hidden;
        }

        .quiz-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s ease;
        }

        .quiz-btn:hover::before {
          left: 100%;
        }

        .primary-btn {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          box-shadow: 0 6px 25px rgba(16, 185, 129, 0.4);
        }

        .primary-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
        }

        .secondary-btn {
          background: rgba(255, 255, 255, 0.9);
          color: #667eea;
          border: 2px solid rgba(102, 126, 234, 0.3);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
        }

        .secondary-btn:hover {
          transform: translateY(-2px);
          background: white;
          border-color: #667eea;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        }

        .btn-icon {
          width: 24px;
          height: 24px;
          fill: currentColor;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 1px solid rgba(229, 231, 235, 0.5);
        }

        .feature-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem;
          background: rgba(102, 126, 234, 0.05);
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .feature-item:hover {
          background: rgba(102, 126, 234, 0.1);
          transform: translateY(-2px);
        }

        .feature-icon {
          width: 32px;
          height: 32px;
          background: rgba(102, 126, 234, 0.2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #667eea;
          flex-shrink: 0;
        }

        .feature-text {
          font-size: 0.9rem;
          color: #374151;
          font-weight: 500;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .quiz-home-container {
            padding: 1rem 0.5rem;
          }
          
          .quiz-card {
            padding: 2rem 1.5rem;
          }

          .buttons-container {
            gap: 0.75rem;
          }

          .quiz-btn {
            padding: 1.25rem 1.5rem;
            font-size: 1rem;
          }

          .features-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 2.2rem;
          }
          
          .quiz-card {
            padding: 1.5rem 1rem;
          }

          .quiz-icon {
            width: 60px;
            height: 60px;
          }
        }
      `}</style>

      <div className="floating-element-1"></div>
      <div className="floating-element-2"></div>
      
      <div className="quiz-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M12,4A0,0 0 0,0 12,4A0,0 0 0,0 12,4M14,9H10A5,5 0 0,0 5,14V17H19V14A5,5 0 0,0 14,9Z"/>
            </svg>
            Quiz Portal
          </div>
          
          <h1 className="main-title">
            Weekly <span className="gradient-text">Quiz</span>
          </h1>
          
          <p className="subtitle">
            Ready to test your knowledge? Challenge yourself and see how you rank against your peers!
          </p>
        </div>

        {/* Main Quiz Card */}
        <div className="quiz-card">
          <div className="card-header">
            <div className="quiz-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"/>
              </svg>
            </div>
            <div className="card-title">Knowledge Assessment</div>
            <div className="card-description">
              Test your understanding with our comprehensive quiz system. Track your progress and compete with fellow students.
            </div>
          </div>

          <div className="buttons-container">
            <button
              className="quiz-btn primary-btn"
              onClick={() => navigate('/quiz')}
            >
              <svg className="btn-icon" viewBox="0 0 24 24">
                <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"/>
              </svg>
              Attempt Quiz
            </button>
            
            <button
              className="quiz-btn secondary-btn"
              onClick={() => navigate('/quiz/leaderboard')}
            >
              <svg className="btn-icon" viewBox="0 0 24 24">
                <path d="M15.5,5A1.5,1.5 0 0,0 14,6.5A1.5,1.5 0 0,0 15.5,8A1.5,1.5 0 0,0 17,6.5A1.5,1.5 0 0,0 15.5,5M12,4A4,4 0 0,1 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M21,14V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V14A2,2 0 0,1 5,12H19A2,2 0 0,1 21,14M19,16H17V20H19V16M15,16H13V20H15V16M11,16H9V20H11V16M7,16H5V20H7V16Z"/>
              </svg>
              View Leaderboard
            </button>
          </div>

          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>
                </svg>
              </div>
              <div className="feature-text">Timed Questions</div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z"/>
                </svg>
              </div>
              <div className="feature-text">Instant Results</div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z"/>
                </svg>
              </div>
              <div className="feature-text">Track Progress</div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M5,16L3,14L12,5L16.5,9.5L15.09,10.91L12,7.83L5,16M19,15.5L18.5,16L17,14.5L17.5,14L19,15.5M22,5L21.5,5.5L20,4L20.5,3.5L22,5M15.47,12.2L12,8.83L10.59,10.24L15.47,12.2Z"/>
                </svg>
              </div>
              <div className="feature-text">Compete & Win</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentQuizHome;